import { supabase } from "@/integrations/supabase/client";

// Invoke an edge function and surface the JSON error message the function
// returned (supabase-js only gives a generic message for non-2xx responses).
export async function invokeEdgeFunction<T>(name: string, body: unknown): Promise<T> {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) {
    let message = error.message;
    try {
      const ctx = await (error as { context?: Response }).context?.json();
      if (ctx?.error) message = ctx.error;
    } catch {
      // keep the generic message
    }
    throw new Error(message);
  }
  if ((data as { error?: string })?.error) throw new Error((data as { error: string }).error);
  return data as T;
}
